import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const QuotationNo = (props) => {
  return (
    <FormGroup controlId="quotationNo">
      <Col componentClass={ControlLabel} sm={4}>
        Quotation No.
      </Col>
    <Col sm={8}>
        <FormControl type="text" autoComplete="off"
          value={props.quotationNo} onChange={props.handleChangeQuotationNo} />
    </Col>
    </FormGroup>
  )
}

QuotationNo.propTypes = {
  quotationNo: PropTypes.string,
  handleChangeQuotationNo: PropTypes.func
};

export default QuotationNo;



// WEBPACK FOOTER //
// ./src/app/components/retrieveQuotationComponent/quotationNo/QuotationNo.js